import { graphql } from '@/generated/gql';

export const NEGOTIATION_CASE_SUPPLIER_INTRODUCTION_MESSAGE_MUTATION = graphql(/* GraphQL */ `
  mutation NegotiationCaseUpdateSupplierIntroductionMessage($id: UUID!, $data: TsrctSupplierIntroductionMessageInput!) {
    tesseract {
      negotiationCase(id: $id) {
        supplierIntroductionMessage {
          update(data: $data) {
            text
            language
          }
        }
      }
    }
  }
`);
